import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const NavBar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  
  const tabs = [
    { path: '/', label: t('nav.home'), icon: '🏠' },
    { path: '/clienti', label: t('nav.clients'), icon: '👥' },
    { path: '/calendario', label: t('nav.calendar'), icon: '📅' },
    { path: '/pacchetti', label: t('nav.packages'), icon: '💰' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-50 md:top-0 md:bottom-auto">
      <div className="max-w-lg mx-auto flex justify-around">
        {tabs.map((tab) => (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`flex flex-col items-center py-3 px-4 transition-colors ${
              location.pathname === tab.path || (tab.path !== '/' && location.pathname.startsWith(tab.path))
                ? 'text-indigo-600 dark:text-indigo-400'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
            data-testid={`nav-${tab.path.replace('/', '') || 'home'}`}
          >
            <span className="text-xl">{tab.icon}</span>
            <span className="text-xs mt-1 font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default NavBar;
